module.exports = __webpack_public_path__ + "img/iconPlay.9313c27d.svg";